/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2024) Takeda. All Rights Reserved
 */

import { CookieSetOptions } from 'universal-cookie';

import { getMainDomain } from '../browser.domain';
import { getCurrentDate } from '../dates/dates.domain';

export const getCookieOptions = (): CookieSetOptions => ({
  ...getBaseOptions(),
  domain: getMainDomain(),
  expires: getExpiration(),
  path: '/',
  partitioned: true
});

const getBaseOptions = (): Partial<CookieSetOptions> => {
  return window.location.host === 'localhost:3000'
    ? { sameSite: 'lax', secure: false }
    : { sameSite: 'none', secure: true };
};

const getExpiration = () => {
  const currentDate = getCurrentDate();
  currentDate.setFullYear(currentDate.getFullYear() + 1);
  return currentDate;
};
